<template>
  <div>
    <b-form @submit="store">
        <div class="row justify-content-center" >
            <div class="col-md-5 col-11">
                <br>
                <p class="text-center"><b>Queremos resolver tus dudas, escríbelas aquí y en breve te contáctaremos:</b></p>              
                <br>
                <div class="col-md-11">
                    <img src="fotos/contacto.png" style="width: 150px; margin-left: -220px;" >
                </div>
                <div class="row" style="margin-top: -150px;">
                    <div class="col-md-6 mt-5">
                        <b-form-input placeholder="Ingrese IDPDV" v-model="idpdv"  type="text" style="border-radius: 6px;box-shadow: inset  0 0 10px 0 #CDCDCD;"/>  
                        <small v-if="errors.includes('idpdv')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>                
                    </div>
                    <div class="col-md-6 mt-5">
                        <b-form-input placeholder="Correo electrónico" v-model="correo"  type="text" style="border-radius: 6px;box-shadow: inset  0 0 10px 0 #CDCDCD;"/>     
                        <small v-if="errors.includes('correo')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>    
                    </div>
                    <div class="col-md-6 mt-5">
                        <b-form-input placeholder="AXC / MRT" v-model="axc"  type="text" style="border-radius: 6px;box-shadow: inset  0 0 10px 0 #CDCDCD;"/>
                        <small v-if="errors.includes('axc')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>                    
                    </div>
                    <div class="col-md-12 mt-5">
                        <b-form-textarea
                            placeholder="Comentarios"
                            rows="3"
                            max-rows="6"
                             style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"
                             v-model="comentario"
                        ></b-form-textarea>  
                        <small v-if="errors.includes('comentario')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorios
                        </small>    
                    </div>
                </div>
                <br>
                <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">
                <center>
                    <b-button type="submit" variant="primary" pill  style="margin-top: 25px; width: 20%; background: #039cf3; border-color: #039cf3;" size="sm" >
                        Enviar  <b-spinner small v-if="loader"></b-spinner>
                    </b-button>
                </center>
    
                <br><br><br>
                
            </div>
         </div>
      </b-form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    name:"Contacto",
    data() {
      return {
        idpdv:"",
        correo:"",
        axc:"",
        comentario:"",
        loader:false,
        errors:[]
      }
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
    },
    methods:{
        store(e){
            e.preventDefault();
            this.loader = true;
            this.errors = []; 
            
            if (!this.idpdv) {
                 this.loader = false;
                 this.errors.push('idpdv');  
            }if (!this.correo){
                 this.loader = false;
                 this.errors.push('correo');      
            }if (!this.axc){
                 this.loader = false;
                 this.errors.push('axc');  
            }if (!this.comentario){
                 this.loader = false;
                 this.errors.push('comentario');   
            }if(this.errors.length == 0){
                let model = this.prepareModel();
                this.$api.post("cantado/contacto", model).then(
                response => {
                    this.loader = false;
                        Swal.fire(
                        "List@",
                        "Correo enviado exitosamente.",
                        'success'
                        )
                        this.clearMode();
                        console.log(response) 
                },
                error => {
                    this.loader = false;
                    if (error.api) {
                         this.errors = error.api; 
                    }
                }
                )
             }
        },
        prepareModel() {
             var model = new FormData();
                model.append("idpdv", this.idpdv);
                model.append("axc", this.axc);
                model.append("comentario", this.comentario);
                model.append("correo", this.correo);
                model.append("perfil", this.user.perfiles[0].perfil.id);
                return model;
        },
        clearMode(){
            this.comentario = "";
        }
    },
    mounted(){
        this.idpdv = this.user.id_pdv;
        this.correo = this.user.email;
        this.axc = this.user.mrt;
    }

}
</script>

<style>

</style>